module.exports = __webpack_public_path__ + "static/media/price-guarantee.98f12972.svg";